// extracted by mini-css-extract-plugin
module.exports = {"linksContainer":"Card_linksContainer__e7fJP","link":"Card_link__cj979"};